import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Zoom from 'react-reveal/Zoom';
import George from "../../../../src/docs/assets/profiles/george.jpg";
import Jiri from "../../../../src/docs/assets/profiles/jiri.jpg";
import Agnes from "../../../../src/docs/assets/profiles/agnes.jpg";
import Bach from "../../../../src/docs/assets/profiles/bach.jpg";
import Leos from "../../../../src/docs/assets/profiles/leos.jpg";
import Aaron from "../../../../src/docs/assets/profiles/aaron.jpg";
import Michele from "../../../../src/docs/assets/profiles/michele.jpg";
import Paul from "../../../../src/docs/assets/profiles/paul.jpg";
import Diana from "../../../../src/docs/assets/profiles/diana.jpg";
import Oliver from "../../../../src/docs/assets/profiles/oliver.jpg";
import Eugene from "../../../../src/docs/assets/profiles/eugene.jpg";
import Santo from "../../../../src/docs/assets/profiles/santo.jpg";
import Jim from "../../../../src/docs/assets/profiles/jim.jpg";
import Thomas from "../../../../src/docs/assets/profiles/thomas.jpg";
import Aubrey from "../../../../src/docs/assets/profiles/aubrey.jpg";
import Emily from "../../../../src/docs/assets/profiles/emily.jpg";
import Gabriel from "../../../../src/docs/assets/profiles/gabriel.jpg";
import Vera from "../../../../src/docs/assets/profiles/vera.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Zoom,
  George,
  Jiri,
  Agnes,
  Bach,
  Leos,
  Aaron,
  Michele,
  Paul,
  Diana,
  Oliver,
  Eugene,
  Santo,
  Jim,
  Thomas,
  Aubrey,
  Emily,
  Gabriel,
  Vera,
  React
};